import React from 'react';
import { Card, Row, Col, Statistic, Typography, List, Avatar, Button, Rate, Tag } from 'antd';
import { BookOutlined, UserOutlined, CalendarOutlined, DollarOutlined, StarOutlined } from '@ant-design/icons';

const { Title } = Typography;

const MentorDashboard: React.FC = () => {
  const upcomingSessions = [
    {
      title: 'React Hooks Derinlemesine',
      mentee: 'Ahmet Yılmaz',
      time: 'Bugün 14:00',
      type: 'Video Call',
      duration: '1 saat'
    },
    {
      title: 'JavaScript ES6+ Özellikleri',
      mentee: 'Elif Kaya',
      time: 'Yarın 10:00',
      type: 'Yüz Yüze',
      duration: '2 saat'
    },
    {
      title: 'Proje Yönetimi',
      mentee: 'Mehmet Demir',
      time: 'Cuma 16:00',
      type: 'Video Call',
      duration: '1.5 saat'
    }
  ];

  const recentReviews = [
    {
      mentee: 'Ahmet Yılmaz',
      rating: 5,
      comment: 'Çok faydalı bir seanstı, teşekkürler!',
      date: '2 gün önce'
    },
    {
      mentee: 'Elif Kaya',
      rating: 5,
      comment: 'Mükemmel açıklamalar, kesinlikle tavsiye ederim.',
      date: '1 hafta önce'
    },
    {
      mentee: 'Mehmet Demir',
      rating: 4,
      comment: 'Güzel bir deneyimdi, devam etmek istiyorum.',
      date: '1 hafta önce'
    }
  ];

  return (
    <div style={{ padding: '24px', background: 'var(--bg-tertiary)', minHeight: '100vh' }}>
      <Title level={2} style={{ marginBottom: '24px' }}>
        Mentör Dashboard
      </Title>

      {/* Statistics Cards */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Toplam Seans"
              value={48}
              prefix={<BookOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Aktif Mentee"
              value={12}
              prefix={<UserOutlined />}
              valueStyle={{ color: 'var(--primary-500)' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Bu Ay Seans"
              value={8}
              prefix={<CalendarOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Aylık Kazanç"
              value={2400}
              prefix={<DollarOutlined />}
              suffix="₺"
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {/* Upcoming Sessions */}
        <Col xs={24} lg={12}>
          <Card title="Yaklaşan Seanslar" extra={<Button type="link">Tümünü Gör</Button>}>
            <List
              itemLayout="horizontal"
              dataSource={upcomingSessions}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button type="link" size="small">Başlat</Button>
                  ]}
                >
                  <List.Item.Meta
                    avatar={<Avatar icon={<CalendarOutlined />} />}
                    title={item.title}
                    description={
                      <div>
                        <div>{item.mentee}</div>
                        <div style={{ color: '#666', fontSize: '12px' }}>
                          {item.time} • {item.type} • {item.duration}
                        </div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* Recent Reviews */}
        <Col xs={24} lg={12}>
          <Card title="Son Değerlendirmeler">
            <List
              itemLayout="horizontal"
              dataSource={recentReviews}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<Avatar icon={<UserOutlined />} />}
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{item.mentee}</span>
                        <Rate disabled defaultValue={item.rating} style={{ fontSize: '14px' }} />
                      </div>
                    }
                    description={
                      <div>
                        <div>{item.comment}</div>
                        <div style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>
                          {item.date}
                        </div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* Quick Actions */}
        <Col xs={24} lg={12}>
          <Card title="Hızlı İşlemler">
            <Row gutter={[8, 8]}>
              <Col xs={12}>
                <Button type="primary" block>
                  Müsaitlik Ayarla
                </Button>
              </Col>
              <Col xs={12}>
                <Button block>
                  Yeni Seans
                </Button>
              </Col>
              <Col xs={12}>
                <Button block>
                  Profil Güncelle
                </Button>
              </Col>
              <Col xs={12}>
                <Button block>
                  Kazançları Gör
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Performance Stats */}
        <Col xs={24} lg={12}>
          <Card title="Performans İstatistikleri">
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Ortalama Puan</span>
                <span>4.8/5</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Rate disabled defaultValue={4.8} style={{ fontSize: '16px' }} />
                <span style={{ marginLeft: '8px', color: '#666' }}>(24 değerlendirme)</span>
              </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Bu Ay Tamamlanan Seans</span>
                <span>8/10</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  width: '100%', 
                  height: '8px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ 
                    width: '80%', 
                    height: '100%', 
                    background: 'var(--success)',
                    borderRadius: '4px'
                  }}></div>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Mentee Memnuniyeti</span>
                <span>95%</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  width: '100%', 
                  height: '8px', 
                  background: '#f0f0f0', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{ 
                    width: '95%', 
                    height: '100%', 
                    background: 'var(--primary-500)',
                    borderRadius: '4px'
                  }}></div>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MentorDashboard;
